

import React from "react";
import arrow from "../../assets/Homepage/Buttonarrow.svg";

import RoundedArrowButton from "../../components/RoundedArrowButton"

const IntroductionSection = () => {
  return (
    <section className="bg-white py-12 md:py-20">
      <div
        className="
          max-w-full mx-auto
          grid grid-cols-12
          gap-5
          px-6 md:px-12 lg:px-24
        "
      >
        {/* Main Heading */}
        <div className="col-span-12">
          <h2 className="font-garamond-subheading md:text-[70px] text-[32px] mb-10 font-normal text-[#2C3075] leading-tight">
            Arambh is dedicated to transforming lives through compassionate
            care, holistic healing, and unwavering support.
          </h2>
        </div>

        {/* Subtext & Button */}
        <div className="col-span-12 md:col-span-6 md:col-start-7 flex flex-col items-start md:items-end">
          <div className="w-full md:w-[546px] border-t border-[#2C3075] pt-4">
            <p className="font-generalsans-description  my-1 text-[#2C3075] font-normal md:text-[20px] leading-[110%] tracking-normal text-[14px]">
              Arambh* — a Sanskrit word meaning beginning or initiation —
              embodies the start of a new chapter. At Arambh Rehab, we
              understand that recovery is more than breaking free from
              addiction; it's about rebuilding life, restoring hope, and
              embracing a brighter future.
            </p>

            {/* Button */}
            <div className="pt-8">
              <RoundedArrowButton label="More about Us" to="/aboutus" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default IntroductionSection;
